import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './modules/zentility/_shared/_zen-legacy-common/_guards/auth.guard';
import {ZenRoutesEnum} from './modules/zentility/_shared/_enums/zen-routes.enum';
import {ZenNotFoundComponent} from './modules/zentility/_shared/_standalone-components/zen-not-found/zen-not-found.component';


const routes: Routes = [
  {path: '', loadChildren: () => import('./modules/zentility/_modules/zen-login/zen-login.module').then(mod => mod.ZenLoginModule)},
  {
    path: '404',
    component: ZenNotFoundComponent,
    data: {message: "Oops, I couldn't find the organization you were looking for.<br />Please check the spelling in the URL."}
  },
  {
    path: ZenRoutesEnum.ADVISOR + '/signup',
    component: ZenNotFoundComponent,
    data: {message: "Oops, I couldn't find the page you were looking for.<br />Please check the spelling in the URL."}
  },
  {
    path: '',
    loadChildren: () => import('./modules/zentility/_modules/zen-forgot-password/zen-forgot-password.module').then(mod => mod.ZenForgotPasswordModule)
  },
  {path: 'signup', redirectTo: '/' + ZenRoutesEnum.CUSTOMER + '/signup'},
  {
    path: 'external-widgets',
    loadChildren: () => import('./modules/external-widgets/external-widgets.module').then(mod => mod.ExternalWidgetsModule)
  },
  {
    path: '',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/zentility/zentility.module').then(mod => mod.ZentilityModule)
  },
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {paramsInheritanceStrategy: 'always'})] // canceledNavigationResolution: 'replace', 
})
export class AppRoutingModule {
}
